export function currentTaxYear(today = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(today).map(part => [part.type, Number(part.value)]));
  const start = parts.month > 4 || (parts.month === 4 && parts.day >= 6) ? parts.year : parts.year - 1;
  return start + '/' + String(start + 1).slice(-2);
}
export function clientAge(dateOfBirth, today = new Date()) {
  if (!dateOfBirth) return '';
  const [year, month, day] = dateOfBirth.split('-').map(Number);
  let age = today.getFullYear() - year;
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age--;
  return age >= 0 ? age : '';
}
export function clientDefaults(profile) {
  const values = { clientName: profile.name, dateOfBirth: profile.dateOfBirth || '', taxYear: currentTaxYear() };
  const age = clientAge(profile.dateOfBirth);
  values.currentAge = age;
  if (profile.retirementAge != null) { values.retirementAge = profile.retirementAge; values.ageAtAnnuity = profile.retirementAge; }
  if (profile.dateOfBirth && profile.retirementAge != null) {
    const [year, month, day] = profile.dateOfBirth.split('-').map(Number);
    const targetYear = year + profile.retirementAge;
    const lastDay = new Date(targetYear, month, 0).getDate();
    const date = `${targetYear}-${String(month).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`;
    values.retirementDate = date; values.annuityDate = date;
  }
  return values;
}
